import React, { useState, useEffect } from 'react';
import API from '../utils/api';

export default function ParentLetterCard({ children = [] }) {
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!children.length) { setLoading(false); return; }
    const firstChild = children[0];
    API.get(`/parent-letter/${firstChild._id}`)
      .then(res => setLetters(res.data.letters || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [children]);

  if (loading || letters.length === 0) return null;

  const latest = letters[0];
  const monthLabel = latest.monthKey
    ? new Date(latest.monthKey + '-01').toLocaleString('en-US', { month: 'long', year: 'numeric' })
    : 'This Month';

  return (
    <div className="card border-0 shadow-sm rounded-4 p-4 mb-4" style={{ background: 'var(--card-bg)' }}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <span style={{ fontSize: '22px' }}>📮</span>
        <div>
          <h6 className="fw-bold mb-0" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
            Your Monthly Story Letter
          </h6>
          <p className="text-muted small mb-0">{monthLabel}</p>
        </div>
        <span className="badge rounded-pill ms-auto" style={{ background: 'var(--purple-section)', color: '#6f42c1', fontSize: '11px' }}>New</span>
      </div>

      <div className="p-3 rounded-3 mb-3" style={{ background: 'var(--item-bg)', border: '1px solid var(--border-purple)' }}>
        {latest.stats?.storiesCount > 0 && (
          <div className="d-flex gap-3 mb-3">
            <div className="text-center">
              <div className="fw-bold" style={{ color: '#6f42c1', fontSize: '20px', fontFamily: "'Fredoka One',cursive" }}>{latest.stats.storiesCount}</div>
              <div className="text-muted" style={{ fontSize: '11px' }}>Stories</div>
            </div>
            {latest.stats.topTheme && (
              <div className="text-center">
                <div className="fw-bold" style={{ color: '#6f42c1', fontSize: '14px', fontFamily: "'Fredoka One',cursive" }}>{latest.stats.topTheme}</div>
                <div className="text-muted" style={{ fontSize: '11px' }}>Top Theme</div>
              </div>
            )}
          </div>
        )}

        <div style={{ color: 'var(--text-body)', fontSize: '14px', lineHeight: 1.7, whiteSpace: 'pre-line',
          overflow: expanded ? 'visible' : 'hidden',
          maxHeight: expanded ? 'none' : '100px',
          maskImage: expanded ? 'none' : 'linear-gradient(to bottom, black 60%, transparent 100%)',
          WebkitMaskImage: expanded ? 'none' : 'linear-gradient(to bottom, black 60%, transparent 100%)',
        }}>
          {latest.letter}
        </div>

        <button className="btn btn-sm btn-link p-0 mt-2" style={{ color: '#6f42c1', fontSize: '13px', textDecoration: 'none' }}
          onClick={() => setExpanded(e => !e)}>
          {expanded ? 'Show less ↑' : 'Read full letter ↓'}
        </button>
      </div>
    </div>
  );
}
